<template>
	<div>
		<el-row class="row-content">
			<el-col :span="24">
				<el-divider/>
				<!--<span style="color: #00afff;font-size: 18px">需要完善信息</span>--><span style="color: #9E9E9E; padding-left: 30px">温馨提示：请完善以下信息，可多次编辑保存</span>
				<el-divider/>
			</el-col>
		</el-row>
		<el-form ref="form" :model="form" :rules="rules" label-width="110px" label-position="right">
			<el-row class="row-content"  span="24">

				<el-col  :span="12">
					<el-form-item label="个人姓名" prop="name">
						<el-input type="text" v-model="detail.name" disabled
						/>
					</el-form-item>
				</el-col>
				<el-col  :span="12">
					<el-form-item label="证件类型" prop="cardType">
						<el-input type="text" v-model="detail.cardType" disabled
						/>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="row-content"  span="24">
				<el-col :span="12">
					<el-form-item label="证件号" prop="cardNumber">
						<el-input type="text" v-model="detail.cardNumber" disabled
						/>
					</el-form-item>
				</el-col>
				<el-col  :span="12">
					<el-form-item label="手机号" prop="llrtel">
						<el-input type="text" v-model="form.llrtel" maxlength="11"
								  placeholder="请输入手机号"
						/>
					</el-form-item>
				</el-col>
			</el-row>
            <el-row class="row-content"  span="24">
                <el-col :span="12">
					<el-form-item label="所在区县" prop="county">
						<el-select v-model="form.county" size="medium" clearable style="width: 16.66625rem;" >
							<el-option
									v-for="item in orgcodeOptions"
									:key="item.deptCode"
									:label="item.shortName"
									:value="item.deptCode">
							</el-option>
						</el-select>
					</el-form-item>
                </el-col>
                <el-col  :span="12">
                </el-col>
            </el-row>
           <!-- <el-row class="row-content">
                <el-col  :span="12">
                    <span style="color: #909399">注：联系人、联系固话对所有用户开放；手机号用于接收平台短信</span>
                </el-col>
            </el-row>-->

			<el-row class="row-content">
				<el-button type="primary" @click="submitForm()">保存信息</el-button>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import {
		getListDept
	} from "@/api/system/dept"
	import {queryDetail,queryFwjgLx,updateJgfw} from "@/api/qygzs/wsqyjbxx";
	export default {
		name:'waGrxx',
		data(){
			return{
				queryParams:{
					uuid:undefined,
				},
				form:{
					/*cardType:undefined,
					name:undefined,
					cardNumber:undefined,
					userType:"1",*/
					llrtel:undefined,
					county:undefined,
					recid:undefined,
					uuid:undefined,
				},
				detail:{
					
				},
				orgcodeOptions:[],
				isGtsh:false,/*是否个体商户，默认为否*/
				isRequired:true,
				serviceOrganOptions:[],
				deptQueryParams:{
					deptLevel:'3',
					deptType:'1'
				},
				rules: {

					county:[
						{ required: true, message: '请选择所在区县', trigger: 'blur' }
					],
                    llrtel:[
                        { required: true, message: '请输入联系手机号', trigger: 'blur' }
                    ],
				},
				ywFwjgRecid:undefined
			}
		},
		created() {
			this.getDetail();
			// this.getFwjgLx();
			this.getdeptlist();
		},
		methods:{
			getdeptlist(){
				getListDept(this.deptQueryParams).then(res => {
					this.orgcodeOptions = res.data;
				})
			},
			checkPhone(){
				let mobile = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/ // 最新16手机正则
				let value = this.form.llrtel;
				if (value !== null && value !==undefined && value !==''){
					if(!mobile.test(value)){
						this.msgWarning("您输入的手机号格式不正确，请重新输入！");
						return false;
					}else{
						return true;
					}
				}else{
					return true;
				}
			},
			checkTel(){
				let tel =  /(^[0-9]{3,4}\-[0-9]{3,8}$)|(^[0-9]{3,8}$)|(^[0−9]3,4[0-9]{3,8}$)|(^0{0,1}13[0-9]{9}$)/ // 座机
				let value = this.form.llrphone;
				if (value !== null && value !==undefined && value !==''){
					if(!tel.test(value)){
						this.msgWarning("您输入的联系固话格式不正确，请重新输入！");
						return false;
					}else{
						return true;
					}
				}else{
					return true;
				}
			},
			checkSynopsis(){

			},

			getDetail(){
				//----需要修改为recid
				let ywFwjgRecid = JSON.parse(localStorage.getItem('ssessionLoginUser')).user.ywFwjgRecid;
				this.queryParams.recid =ywFwjgRecid;
				this.loading = true;
				queryDetail(this.queryParams).then(response => {
					// console.log(response)
					// this.isGtsh = response.isGtsh;
					// this.form.type=response.type;
					// this.form.name=response.name;
					this.form.llrtel=response.llrtel;
					// this.form.cardType=response.cardType;
					// this.form.cardNumber=response.cardNumber;
					this.form.county=response.county;
					this.form.recid=response.recid;
					this.detail=response;
					this.form.uuid=JSON.parse(localStorage.getItem('ssessionLoginUser')).ywFwjg.uuid;
					// console.log("111",this.form)
					this.loading = false;
					// this.typeChange();
				});
				//----【】需要修改为recid
				this.ywFwjgRecid = JSON.parse(localStorage.getItem('ssessionLoginUser')).user.ywFwjgRecid;
			},
			submitForm() {
				// window.location.reload();
				 if (this.utils.isLoginTimeout()) {
					this.$refs["form"].validate(valid => {
						if(valid && this.checkPhone() && this.checkTel()){
							this.$confirm('是否确认保存当前信息？', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.saveForm();
							})
						}
					})
				} else {
					this.$confirm('登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
					    this.logout(this.ywFwjgRecid)
					})
				}
			},
			saveForm(){
				// console.log(this.form)
				// this.form.userType='1';
				// console.log("222",this.form)
                updateJgfw(this.form).then(response => {
					if (response.code === 200) {
						let loginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
						let user = loginUser.user;
						user.finishedInfo = 'Y';
						loginUser.user = user;
						let ywFwjg = loginUser.ywFwjg;
						loginUser.ywFwjg = ywFwjg;
						localStorage.setItem("ssessionLoginUser",JSON.stringify(loginUser));
                        this.msgSuccess("保存成功");
						// this.$emit("update:isQyxxWS",false);
						window.location.reload();
					} else {
						this.msgError(response.msg);
					}
				});
			},
			toOpenPage(topath) {
				this.$router.push({
					path: topath
				})
				this.$store.commit('SET_MAININDEX', topath);
			},
		}
	}
</script>

<style scoped="scoped">
	.jbxx-title{
		color: #409EFF;
		font-size: 1.25rem;
		font-weight: 700;
		margin-bottom: 0.625rem;
		text-align: left;
	}
	.entanme-title{
		background-color: #ebebeb;
		text-align: left;
		min-height: 30px;
		line-height: 1.875rem;
		padding: 0.625rem;
		margin-bottom: 1rem;
	}
	.entname{
		font-size: 18px;
		font-weight: 700;
	}
	.row-content{
		margin-bottom: 1rem;
		text-align: left;
	}
</style>
